import { withFmaSliceSettings, fmaFieldParameters, fmaListingParameter } from './shared.js';

export default {
  label: 'Distortion vs. Field', group: 'performance',
  description: 'Distortion magnitude and direction across the field.',
  settingsSchema: withFmaSliceSettings({}),
  parameters: [...fmaFieldParameters, fmaListingParameter],
  coverage: 'Along the X or Y axis of the field. Displacement is in lens units, or in milliradians for afocal systems; afocal systems need angular field coordinates. Values are displacements, not percentages, and are not calibrated. Not supported: oblique slices, calibrated or PSF-centroid distortion, and two-dimensional maps (see Distortion Map).',
} as const;
